type InputData = Array<{
  id: string;
  label: string;
  type: string;
}>;

export const createKeyValuePairs = (inputData: InputData) => {
  const keyValuePairs: Record<string, string> = {};
  inputData.forEach((field) => {
    keyValuePairs[field.id] = '';
  });
  return keyValuePairs;
};

export const getIdealImageSize = (width: number | 'auto', height: number | 'auto') => {
  const heightValue = height === 'auto' ? 'auto' : `${height}`;
  const widthValue = width === 'auto' ? 'auto' : `${width}`;
  return `Ideal size: ${widthValue} * ${heightValue}`;
};

/** Replace camelCase or PascalCase with a space before each uppercase letter and capitalize the first letter */
export const convertToNormalEnglish = (text: String) => {
  const result = text
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase letters
    .replace(/^./, text[0].toUpperCase()); // Capitalize the first letter
  return result;
};
